module.exports = __webpack_public_path__ + "static/Brucheta-072c1a4c10dd40b4307f652fb0903e13.png";